import { Slide } from "@jelly/lesson";
import config from "appConfig";

import { task as task01 } from "../../../../../task/course-04/lesson-07/task-01";

const task: Slide = {
  titleHtml: `A sound wave of 1 kHz is exciting the microphone’s membrane with a pressure level of 94 dB.<br />The microphone output signal is shown on the oscilloscope screen. Calculate the sensitivity<br />of the microphone in mV/Pa. dB are calculated with RMS pressure values!`,
  description: "Fill in the value.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [4, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/04/07/task/task-1-item-1.png`,
                },
              },
              styles: {
                padding: "5%",
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task01.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
